module.exports = "import { table: Table } from 'env';\nimport { setTimeout: Later } from 'env';\nimport { log: Log } from 'env';\n\ntype Log = (i32) => void;\ntype Later = (Function, i32) => void;\n\nfunction echo(): void {\n  log(42);\n}\n\nexport function test(): void {\n  setTimeout(echo, 5);\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./examples/walt/function-pointer.walt
// module id = 925
// module chunks = 0